import React from 'react';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { VetDetailsPropTypes } from '../../../propTypes/vetDetails';
import { GetAddressParts } from '../../../helpers/vetHelpers';

import './vetDetailsSummary.scss';

export const VetDetailsSummary = ({ vetDetail }) => {
  const { serviceProvider, ServiceProviderName, phoneNumber, ServiceProviderContactNumber } = vetDetail;

  const addresses = GetAddressParts({ vetDetail });

  const practiceAddress = addresses.filter((address) => address).join(', ');

  return (
    <div className="vetDetailsSummary">
      <div className="labelValuePair practiceName">
        <Icon icon="veterinarian" />
        <span className="labelText">Practice name</span>
        <span className="valueText">{serviceProvider || ServiceProviderName || '-'}</span>
      </div>

      <div className="labelValuePair practiceAddress">
        <Icon icon="street-signs" />
        <span className="labelText">Practice address</span>
        <span className="valueText">{practiceAddress || '-'}</span>
      </div>

      <div className="labelValuePair practiceContact">
        <Icon icon="phone-outline" />
        <span className="labelText">Contact number</span>
        <span className="valueText">{phoneNumber || ServiceProviderContactNumber || '-'}</span>
      </div>
    </div>
  );
};

VetDetailsSummary.propTypes = {
  vetDetail: VetDetailsPropTypes
};
